import { mediaQueryStyles, constants } from "@newsela/angelou";

const { mediaQuery: breakpoint } = mediaQueryStyles;

export const containerCss = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: 20,
};

export const gradeSelectionCss = {
  [breakpoint.downTo("xs")]: {
    flex: "calc(2/3)",
  },
};

export const submitContainerCss = {
  display: "flex",
  alignItems: "center",
  width: "100%",
};

export const saveButtonCss = {
  root: {
    width: "100%",
    [breakpoint.downTo(constants.breakpoints.BreakpointNames.xs)]: {
      width: "auto",
    },
  },
};

export const savingLoadingCss = {
  root: {
    margin: 0,
    marginLeft: 10,
    width: 30,
    height: 30,
  },
};
